<div class="flex flex-col gap-6">
  <div>
    <h2 class="text-xl font-bold text-gray-800 dark:text-white">
      Définition des usines
    </h2>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      Sélectionnez une usine et mettez à jour sa description. Cette description
      est utilisée pour enrichir le contexte lors de la priorisation des ordres
      de travail.
    </p>
  </div>

  <div *ngIf="isLoading" class="flex justify-center items-center py-16">
    <i class="pi pi-spin pi-spinner text-4xl text-blue-500"></i>
  </div>

  <div
    *ngIf="!isLoading"
    class="bg-white dark:bg-zinc-800 rounded-2xl shadow-sm border border-zinc-100 dark:border-zinc-700 p-6"
  >
    <div class="flex flex-col gap-5">
      <div class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >Usine</label
        >
        <p-select
          [options]="plants"
          [(ngModel)]="selectedPlant"
          optionLabel="SapPlantId"
          placeholder="Sélectionnez une usine"
          (onChange)="onPlantSelect()"
          class="w-64"
        >
          <ng-template pTemplate="selectedItem" let-plant>
            <span *ngIf="plant">{{ plant.SapPlantId }}</span>
          </ng-template>
          <ng-template pTemplate="item" let-plant>
            <span>{{ plant.SapPlantId }}</span>
          </ng-template>
        </p-select>
      </div>

      <div *ngIf="selectedPlant" class="flex flex-col gap-1">
        <label class="text-sm font-medium text-gray-700 dark:text-gray-300"
          >Description</label
        >
        <textarea
          pTextarea
          [(ngModel)]="editDescription"
          rows="6"
          placeholder="Entrez une description pour cette usine..."
          class="w-full resize-y"
        ></textarea>
        <p class="text-xs text-gray-400 dark:text-gray-500 mt-1">
          Décrivez le contexte opérationnel de cette usine (type de production,
          équipements critiques, contraintes, ...).
        </p>
      </div>

      <div *ngIf="selectedPlant" class="flex justify-end">
        <p-button
          label="Sauvegarder"
          icon="pi pi-save"
          [loading]="isSaving"
          (click)="save()"
          severity="primary"
        />
      </div>

      <div
        *ngIf="!selectedPlant"
        class="text-center py-8 text-gray-400 dark:text-gray-500"
      >
        <i class="pi pi-building text-4xl mb-3 block"></i>
        <p>Sélectionnez une usine pour modifier sa description.</p>
      </div>
    </div>
  </div>
</div>
